import type { ApiRoutes } from '@hana/data';
import { apiRoutes as ezy } from '@hana/zone-ezy';
import { apiRoutes as mee } from '@hana/zone-mee';

/** Thực thể đọc từ worker `api`. Khi một vùng có route thật (A-06, A-08) + hàm đổi JSON → kiểu của màn, khai ở đây; màn không phải sửa. */
export const API_ROUTES: ApiRoutes = { ...ezy, ...mee };
